import { Breadcrumbs, Grid, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import React from "react"
import { Link } from "react-router-dom"
import { ambiente } from "../../utils/Enum"
import mapeamentoNomeRota from "../../utils/MapeamentoNomeRota"
import { configureEnvironment } from "./../../../config/env"
import { statusLotePreenchimento } from "../../utils/Constantes"

const BreadcrumbItem = (props) => {
	const classes = useStyles()
	const path = props.location.pathname.split("/").filter((elemento) => elemento !== "" && !elemento.includes("|"))
	const search = props.location.search;

	const ambienteHomologacao = configureEnvironment().REACT_APP_NOME_AMBIENTE === ambiente.homologacao
	
	return (
		<Breadcrumbs separator="|" aria-label="Breadcrumb">
			{ambienteHomologacao ? (
				<React.Fragment>
					<span key="ambienteHomologacao" className={classes.homologacao}>
						HOMOLOGAÇÃO
					</span>
					<span className={classes.separador}>|</span>
					<Link className={classes.link} to={"/"}>
						Onboarding
					</Link>
				</React.Fragment>

			) : (

					<Link className={classes.link} to={"/"}>
						Onboarding
					</Link>
				)}

			{RenderizaBreadcrumb(path, search)}
		</Breadcrumbs>
	)
}

const RenderizaBreadcrumb = (path, search) => {
	const classes = useStyles()
	//TODO - Fazer lógica de landing page aqui
	if (path.length === 0) {
		return (
			<Typography key="amostras" color="inherit" className={classes.linkSelected}>
				{mapeamentoNomeRota("amostras", search)}
			</Typography>
		)
	} else {
		return path.map((elemento, posicao) => {
			const nomeRota = mapeamentoNomeRota(elemento, search);

			if (posicao === path.length - 1) {
				return (
					<Grid key={elemento} container direction="row" spacing={1} alignItems="center" justify="center">
						<Grid item>
							<span color="inherit" className={classes.linkSelected}>
								{nomeRota}
							</span>

							{(nomeRota === "Novo lote" || nomeRota === "Editar lote") &&
								<span color="inherit" className={classes.statusLotePreenchimento}>
									{statusLotePreenchimento}
								</span>
							}
						</Grid>
					</Grid>
				)				
			}
			else {
				return (
					<Link key={elemento} color="inherit" className={classes.link} to={`/${elemento}`}>
						{mapeamentoNomeRota(elemento, search)}
					</Link>
				)
			}
		})
	}
}

const useStyles = makeStyles({
	link: {
		color: "#61688B",
		fontWeight: "normal",
		fontStyle: "normal",
		textDecoration: "none",
		fontSize: "10.2pt",
	},
	linkSelected: {
		color: "#61688B",
		fontWeight: "bold",
		fontStyle: "normal",
		textDecoration: "none",
		cursor: "default",
		fontSize: "10.2pt",
		letterSpacing: "0.5px",
	},
	statusLotePreenchimento: {
		color: "#FF444E",
		fontWeight: "580",
		fontStyle: "normal",
		textDecoration: "none",
		cursor: "default",
		fontSize: "10.2pt",
		letterSpacing: "0.5px",
		paddingLeft: "8px"
	},
	homologacao: {
		color: "#BF43AB",
		fontWeight: "bold",
		fontStyle: "normal",
		textDecoration: "none",
		cursor: "default",
		fontSize: "10.2pt",
		letterSpacing: "0.5px",
	},

	separador: {
		color: "#61688B",
		fontSize: "1rem",
		lineWeight: "1.5",
		marginLeft: "8px",
		marginRight: "8px",
	}

})

export default BreadcrumbItem
